import { ethers } from 'ethers';
import SocialVaultContract from '../artifacts/contracts/SocialVaultFactory.sol/SocialVaultFactory.json';

const contractAddress = process.env.REACT_APP_SOCIAL_VAULT_FACTORY_CONTRACT;
const provider: any = new ethers.providers.Web3Provider((window as any).ethereum);

const userSocialVault: any = new ethers.Contract(
  (contractAddress as string),
  SocialVaultContract.abi,
  provider.getSigner()
);

const dappSocialVault: any = new ethers.Contract(
  (contractAddress as string),
  SocialVaultContract.abi,
  ethers.getDefaultProvider(process.env.REACT_APP_DEFAULT_NETWORK)
);

export { provider, userSocialVault, dappSocialVault };
